import type { Event } from '@patsnap/tahiti-core/common/event';
import type { TranslationSettings, TargetSetting, TargetVisibleSetting } from '../types';

export const TranslationSettingsService = Symbol.for('TranslationSettingsService');

export interface TranslationSettingsService {
    readonly onStatesChange: Event<TranslationSettings>;

    getModelData(): TranslationSettings;
    setTranslation(target: TargetSetting): void;
    setTranslationVisible(target: TargetVisibleSetting): void;
}
